import Platform from './platform';
import User from './user';
import Account from './account';
import Invitation from './invitation';
import Transfers from './transfers';
import TransfersReceived from './transfers-received';
import Reminder from './reminder';
import Wallpaper from './wallpaper';
import UI from './ui';
import Invoices from './invoices';
import ApiGrants from './apigrants';
import Advertise from './advertise';
import BillingDetails from './billingdetails';

export default {
  Platform,
  User,
  Account,
  Invitation,
  Transfers,
  TransfersReceived,
  Reminder,
  Wallpaper,
  UI,
  Invoices,
  ApiGrants,
  Advertise,
  BillingDetails,
};
